import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  input,
} from '@angular/core';

import type { MenuItemType } from '@evc/web-components';
import {
  ActionService,
  ButtonComponent,
  HorizontalWheelScrollDirective,
  IsScrollableDirective,
  OptionalAsyncPipe,
} from '@evc/web-components';

import { SearchService } from '../../search/search.service';
import { AppIdentity } from '../../types/app-identity.type';
import { PRIMARY_NAVIGATION_HOSTS, type PrimaryNavigationHosts } from '../types';

@Component({
  selector: 'evc-navigation-primary',
  imports: [
    ButtonComponent,
    HorizontalWheelScrollDirective,
    IsScrollableDirective,
    OptionalAsyncPipe,
  ],
  templateUrl: './navigation-primary.html',
  styleUrls: ['./navigation-primary.scss', './navigation-primary-ims.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-host]': 'host()',
    '[attr.data-theme]': "isImsTopbar() ? 'ims' : null",
  },
})
export class NavigationPrimaryComponent {
  readonly items = input<MenuItemType[]>([]);
  readonly host = input<PrimaryNavigationHosts>(PRIMARY_NAVIGATION_HOSTS.TOPBAR);
  readonly isIms = input(false);
  public readonly appIdentity = input<AppIdentity>();

  protected readonly isImsTopbar = computed(
    () => this.isIms() && this.host() === PRIMARY_NAVIGATION_HOSTS.TOPBAR,
  );

  #destroyRef = inject(DestroyRef);
  #actionService = inject(ActionService);
  #searchService = inject(SearchService, { optional: true });

  protected onItemClick(tab: MenuItemType): void {
    this.#searchService?.clearSearch();
    this.#setSelectedTab(tab);
    this.#actionService.handleAction(tab, this.#destroyRef);
  }

  protected readonly buttonFrame = computed((): 'none' | 'ghost' =>
    this.isImsTopbar() ? 'none' : 'ghost',
  );
  protected getItemType(item: MenuItemType): 'primary' | 'neutral' {
    return this.isImsTopbar() || !item.selected ? 'neutral' : 'primary';
  }

  #setSelectedTab(clickedTab: MenuItemType): void {
    this.items()?.forEach((tab) => {
      if (tab.selected) {
        tab.selected = false;
      }

      if (tab.key === clickedTab.key) {
        tab.selected = true;
      }
    });
  }
}
